import { getQuestion, submitQuestion, getScoreInfo } from '../../server/questions'

const state = {
  index: 1,
  questionNum: 0,
  showQuestion: {},
  questions: {},
  answers: {},
  radioList: [],
  checkList: [],
  judgeList: [],
  disableUp: true,
  disableDown: false,
  submissionId: null,
  finished: 0,
  wrongNum: 0,
  rightNum: 0,
  isShowScore: false,
  scoreInfo: {},
  isShowAnalysis: false,
  timer: null,
  showTime: '00:00'
}

const mutations = {
  SELECT_QUESTION: ({ questions }, type) => {
    if (type === 'up' && state.index > 1) {
      state.index--
    }
    if (type === 'down' && state.index < state.questionNum) {
      state.index++
    }
    if (type.type === 'card') {
      state.index = type.index
    }
    if (state.index == 1) {
      state.disableUp = true
    } else {
      state.disableUp = false
    }
    if (state.index == state.questionNum) {
      state.disableDown = true
    } else {
      state.disableDown = false
    }
    state.showQuestion = questions[state.index]
  },
  ADD_ANSWER: (state, data) => {
    let obj = {}
    obj[data.id] = data
    state.answers = Object.assign({}, state.answers, obj)
  },
  DELETE_ANSWER: (state, key) => {
    delete state.answers[key]
    state.answers = Object.assign({}, state.answers)
  },
  CREATE_QUESTION: (state, data) => {
    const { questionList, submissionId, finished } = data
    state.questions = {}
    state.radioList = []
    state.checkList = []
    state.judgeList = []
    questionList.forEach((item, index) => {
      let i = index + 1
      item.index = i
      state.questions[i] = item
      // 答题卡信息
      let card = {
        isAnswer: 4,
        index: i,
        id: item.questionMainId
      }
      if (item.myAnswer && item.myAnswer.isCorrect === 1) {
        card.isAnswer = 1
        state.rightNum++
      }
      if (item.myAnswer && item.myAnswer.isCorrect === 0) {
        card.isAnswer = 0
        state.wrongNum++
      }
      if (item.questionType === 'SINGLE_CHOICE') {
        state.radioList.push(card)
      }
      if (item.questionType === 'MULTI_CHOICE') {
        state.checkList.push(card)
      }
      if (item.questionType === 'JUDGE_CHOICE') {
        state.judgeList.push(card)
      }
    })
    state.showQuestion = state.questions[1]
    state.questionNum = questionList.length
    state.submissionId = submissionId
    state.finished = finished
    // state.scoreInfo = stat
  },
  TIMER: (state) => {
    var [minute, second] = [0, 0]
    state.timer = setInterval(() => {
      second++
      if (second === 60) {
        second = 0
        minute++
      }
      state.showTime = (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second)
    }, 1000)
  },
  FINISHED: (state) => {
    state.finished = 1
  },
  IS_SHOW_SCORE: (state) => {
    if (state.isShowScore) {
      state.isShowScore = false
    } else {
      state.isShowScore = true
    }
  },
  FIND_ANALYSIS: (state) => {
    state.isShowAnalysis = true
  },
  CLOSE_ANALYSIS: (state) => {
    state.isShowAnalysis = false
  },
  CLOSE_TIMER: (state) => {
    clearInterval(state.timer)
  },
  GET_USER_SCORE_INFO: (state, data) => {
    let obj = data
    obj.list = []
    obj.list.push(data)
    state.scoreInfo = obj
  }
}

const actions = {
  selectQuestion ({ commit }, type) {
    commit('SELECT_QUESTION', type)
  },
  findAnalysis ({ commit }) {
    commit('FIND_ANALYSIS')
  },
  colseAnalysis ({ commit }) {
    commit('CLOSE_ANALYSIS')
  },
  closeTimer ({ commit }) {
    commit('CLOSE_TIMER')
  },
  addAnswer ({ commit }, data) {
    commit('ADD_ANSWER', data)
  },
  deleteAnswer ({ commit }, key) {
    commit('DELETE_ANSWER', key)
  },
  getQuestion ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getQuestion(params).then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          commit('CREATE_QUESTION', data)
          if (data.finished === 0) commit('TIMER')
          this.dispatch('questions/getScore', {
            submissionId: data.submissionId,
            courseType: params.courseType
          })
        } else {
          alert(msg)
        }
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  getScore ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getScoreInfo(params).then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          commit('GET_USER_SCORE_INFO', data)
        } else {
          alert(msg)
        }
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  submitQuestion ({ commit }, params) {
    params.submissionId = state.submissionId
    return new Promise((resolve, reject) => {
      submitQuestion(params).then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          commit('SELECT_QUESTION', {type: 'card', index: 1})
          commit('CREATE_QUESTION', data)
          commit('FINISHED')
          commit('IS_SHOW_SCORE')
          commit('CLOSE_TIMER')
          this.dispatch('questions/getScore', {
            submissionId: state.submissionId,
            courseType: params.courseType
          })
        } else {
          alert(msg)
        }
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  findScore ({ commit }, data) {
    commit('IS_SHOW_SCORE')
    this.dispatch('questions/getScore', {
      courseType: data.courseType,
      submissionId: data.submissionId
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/questions.js